import axios from "../http-common";
import history from "../services/history";
import CatalogoService from "../services/catalogo";
import * as actionTypes from "../actions/types";

export const actualizarAtriutoPresentacion = (objeto) => (dispatch) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_ATRIBUTO_PRESENTACION,
        payload: objeto,
    });
};

export const seleccionarPrestador = (prestador) => (dispatch) => {
    dispatch(
        actualizarAtriutoPresentacion({ prestadorSeleccionado: prestador })
    );
};

const validarArregloArchivos = (arreglo) => {
    let esValido = false;

    for (let i = 0; i < arreglo.length; i++) {
        const archivo = arreglo[i];

        if (
            !archivo.bajaLogica &&
            (!archivo.nombreArchivo.includes("_original.") ||
                !archivo.pathArchivo.includes("/prestaciones/"))
        ) {
            // solo un archivo es necesario
            esValido = true;
            break;
        }
    }

    return esValido;
};

export const actualizarFacturaFile = (archivos) => (dispatch) => {
    dispatch({ type: actionTypes.ACTUALIZAR_FACTURA_FILE, payload: archivos });

    // Tiene que ser un solo archivo
    const comprobanteValido = archivos.some((arch) => !arch.bajaLogica);
    dispatch(actualizarRequeridosEsValido("facturas", comprobanteValido));
};

export const actualizarImagenesFiles = (archivos) => (dispatch) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_IMAGENES_FILES,
        payload: archivos,
    });

    const archivosValidos = validarArregloArchivos(archivos);
    dispatch(actualizarRequeridosEsValido("imagenes", archivosValidos));
};

export const inicializarNuevaPresentacion = () => (dispatch) => {
    dispatch({
        type: actionTypes.INICIALIZAR_NUEVA_PRESENTACION,
    });
};

export const actualizarLiquidacionesFiles = (archivos) => (dispatch) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_LIQUIDACIONES_FILES,
        payload: archivos,
    });

    const archivosValidos = validarArregloArchivos(archivos);
    dispatch(actualizarRequeridosEsValido("liquidaciones", archivosValidos));
};

export const actualizarPrestacionesFiles = (archivos) => (dispatch) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_PRESTACIONES_FILES,
        payload: archivos,
    });

    const archivosValidos = validarArregloArchivos(archivos);
    dispatch(actualizarRequeridosEsValido("prestaciones", archivosValidos));
};

const validarInternacion = (internacion) => {
    let intValida = false;
    for (let j = 0; j < internacion.detalles.length; j++) {
        const archivo = internacion.detalles[j];

        if (!archivo.bajaLogica) {
            intValida = true;
            break;
        }
    }

    return intValida;
};

export const validarArregloInternaciones = (arreglo) => {
    let esValido = true;
    let bajas = 0;
    for (let i = 0; i < arreglo.length; i++) {
        const internacion = arreglo[i];

        let intValida = validarInternacion(internacion);
        esValido = esValido && intValida;
        bajas = !internacion.bajaLogica ? bajas : bajas + 1;
    }

    return esValido && bajas !== arreglo.length;
};

export const actualizarInternaciones = (internaciones) => (dispatch) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_INTERNACIONES,
        payload: internaciones,
    });

    const archivosValidos = validarArregloInternaciones(internaciones);
    dispatch(actualizarRequeridosEsValido("internaciones", archivosValidos));
    if (!archivosValidos) {
        dispatch(actualizarAtriutoPresentacion({ submitValido: false }));
    }
};

export const actualizarNroInternacion = (index, nroInternacion) => (
    dispatch
) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_NRO_INTERNACION,
        payload: { index: index, nroInternacion: nroInternacion },
    });
};

export const actualizarEmailResponsable = (email) => (dispatch) => {
    dispatch(actualizarAtriutoPresentacion({ emailResponsable: email }));
};

export const actualizarTelefonoResponsable = (telefono) => (dispatch) => {
    dispatch(actualizarAtriutoPresentacion({ telefonoResponsable: telefono }));
};

export const buscarInternacion = (nroInternacion) => (dispatch, getState) => {
    const internaciones = getState().nuevaPresentacionReducer.internaciones;
    let i = 0;
    while (
        i < internaciones.length &&
        internaciones[i].nroInternacion !== parseInt(nroInternacion)
    )
        i++;
    return i === internaciones.length ? false : internaciones[i];
};

export const actualizarNroFactura = (nroFactura) => (dispatch) => {
    dispatch(actualizarAtriutoPresentacion({ nroFactura: nroFactura }));
};

export const actualizarFechaEmisionComp = (fechaEmisionComp) => (dispatch) => {
    dispatch(actualizarAtriutoPresentacion({ fechaEmisionComp: fechaEmisionComp }));
};

export const actualizarNroReferencia = (nroReferencia) => (dispatch) => {
    dispatch(actualizarAtriutoPresentacion({ nroReferencia: nroReferencia }));
};

export const seleccionarTipoPrestacion = (prestacionId) => (dispatch) => {
    dispatch(
        actualizarAtriutoPresentacion({
            tipoPrestacionSeleccionada: prestacionId,
        })
    );
};

export const seleccionarTipoComprobante = (comprobante) => (dispatch) => {
    dispatch(
        actualizarAtriutoPresentacion({
            tipoComprobantesSeleccionado: comprobante.id,
            codigosComprobante: comprobante.codigos,
        })
    );
};

export const seleccionarCodigoComprobante = (codigo) => (dispatch) => {
    dispatch(
        actualizarAtriutoPresentacion({
            codigoComprobanteSeleccioado: codigo.id,
            letraComprobante: codigo.letra,
        })
    );
};

export const seleccionarTipoDePresentacion = (tipoPresentacionId) => (
    dispatch
) => {
    dispatch(
        actualizarAtriutoPresentacion({
            tipoPresentacionSeleccionada: tipoPresentacionId,
        })
    );
};

export const buscarTiposComprobantes = () => (dispatch) => {
    return CatalogoService.listadoComprobantes().then((response) =>
        dispatch(
            actualizarAtriutoPresentacion({
                tipoComprobantes: response.data,
            })
        )
    );
};

export const buscarTiposComprobantesPresentacion = (idPresentacion) => (dispatch) => {
    return CatalogoService.listadoTipoComprobantesByTipoPresentacion(idPresentacion).then((response) =>
        dispatch(
            actualizarAtriutoPresentacion({
                tipoComprobantes: response.data,
            })
        )
    );
};

export const buscarTiposPresentaciones = () => (dispatch) => {
    return CatalogoService.listadoTipoPresentaciones().then((response) =>
        dispatch(
            actualizarAtriutoPresentacion({
                tipoPresentaciones: response.data,
            })
        )
    );
};

export const buscarTiposPrestaciones = () => (dispatch) => {
    return CatalogoService.listadoTipoPrestaciones().then((response) =>
        dispatch(
            actualizarAtriutoPresentacion({
                tipoPrestaciones: response.data,
            })
        )
    );
};

export const buscarTiposPrestacionesPresentacion = (idPresentacion) => (dispatch) => {
    return CatalogoService.listadoTipoPrestacionesByTipoPresentacion(idPresentacion).then((response) =>
        dispatch(
            actualizarAtriutoPresentacion({
                tipoPrestaciones: response.data,
            })
        )
    );
};

export const recuperarPathTemporalParaArchivos = (idPresentacion = null) => (
    dispatch,
    getState
) => {
    let formData = new FormData();
    let prestadorActivo = getState().authReducer.prestadorActivo;

    if (prestadorActivo === null) {
        prestadorActivo = JSON.parse(sessionStorage.getItem("prestadorActivo"));
    }

    const codigoPrestador = prestadorActivo.codPrestador;

    formData.append("prestador", codigoPrestador);

    if (idPresentacion) {
        formData.append("presentacion", idPresentacion);
    }

    axios.post("presentaciones/files/temp", formData).then((response) => {
        dispatch(
            actualizarAtriutoPresentacion({ pathTemporal: response.data })
        );
    });
};

const verificarArchivosInternaciones = (internaciones, dispatch, getState) => {
    let faltaArchivo = false;
    internaciones.forEach((internacion, i) => {
        if (internacion.nroInternacion && internacion.detalles.length===0){
            faltaArchivo = true;
        }
    })
    if (!faltaArchivo){
        const internacion = getState().internacionesReducer.internacion;
        if (internacion.nroInternacion && internacion.detalles.length===0){
            faltaArchivo = true;
        }
    }
    if (faltaArchivo){
        const ventanaConfig = {
            estaVisible: true,
            titulo: "Adjunta el archivo de internación",
            mensaje: `Para continuar debes subir el archivo para la internación o eliminarla.`,
            esAlerta: true,
            clickAceptar: () => {
                dispatch({
                    type: actionTypes.ACTUALIZAR_ATRIBUTOS_VENTANA,
                    payload: { estaVisible: false },
                });
            },
        };
        dispatch({
            type: actionTypes.ACTUALIZAR_ATRIBUTOS_VENTANA,
            payload: ventanaConfig,
        });
        dispatch(
            actualizarAtriutoPresentacion({
                mostrarBackdrop: false,
            })
        );
    }
    return faltaArchivo;
}

export const enviarNuevaPresentacion = () => (dispatch, getState) => {
    dispatch(actualizarAtriutoPresentacion({ mostrarBackdrop: true }));

    const {
        prestadorSeleccionado,
        pathTemporal,
        tipoComprobantesSeleccionado,
        emailResponsable,
        telefonoResponsable,
        nroFactura,
        fechaEmisionComp,
        nroReferencia,
        facturaFile,
        internaciones,
        prestaciones,
        imagenesFiles,
        liquidacionesFiles,
        tipoPresentacionSeleccionada,
        codigoComprobanteSeleccioado,
        tipoPrestacionSeleccionada,
    } = getState().nuevaPresentacionReducer;

    const idTipoPresentacion =
        tipoPresentacionSeleccionada !== ""
            ? tipoPresentacionSeleccionada
            : prestadorSeleccionado.tipoPresentacion;

    const presentacion = {
        codPrestador: prestadorSeleccionado.codPrestador,
        razonSocial: prestadorSeleccionado.razonSocial,
        idTipoPresentacion: idTipoPresentacion,
        contactoEmail: emailResponsable,
        contactoTelefono: telefonoResponsable,
        tempPath: pathTemporal,
        internaciones: [...internaciones],
        prestaciones: [...prestaciones],
        imagenes: [...imagenesFiles],
        liquidaciones: [...liquidacionesFiles],
        comprobantes: [],
    };

    if (idTipoPresentacion===3 || tipoPrestacionSeleccionada===3){
        delete presentacion.internaciones;
        presentacion.internacionesSocios = [...internaciones];
        const faltaArchivo = verificarArchivosInternaciones(internaciones, dispatch, getState);
        if (faltaArchivo){
            return;
        }
    }

    if (facturaFile.length > 0) {
        presentacion.comprobantes = [
            {
                detalles: [...facturaFile],
                nroComprobante: nroFactura,
                fechaEmisionComp:
                    tipoComprobantesSeleccionado === 1 &&
                    (codigoComprobanteSeleccioado === 3 || codigoComprobanteSeleccioado === 4)?
                    fechaEmisionComp : null,
                nroReferencia: nroReferencia,
                idTipoComprobante: tipoComprobantesSeleccionado,
                idTipoComprobanteCodigo: codigoComprobanteSeleccioado,
                idTipoPrestacion: tipoPrestacionSeleccionada,
            },
        ];
    }

    axios
        .post("presentaciones/", presentacion)
        .then((response) => {
            // Reiniciar los datos actuales de presentacion
            // Enviar al usuario a la grilla de presentaciones
            const ventanaConfig = {
                estaVisible: true,
                titulo: "Creación de nueva presentación",
                mensaje: `La presentación nº ${response.data} fue enviada con éxito`,
                clickAceptar: () => {
                    dispatch({
                        type: actionTypes.ACTUALIZAR_ATRIBUTOS_VENTANA,
                        payload: { estaVisible: false },
                    });
                    history.push("/");
                },
            };
            dispatch({
                type: actionTypes.ACTUALIZAR_ATRIBUTOS_VENTANA,
                payload: ventanaConfig,
            });
            dispatch(
                actualizarAtriutoPresentacion({
                    mostrarBackdrop: false,
                })
            );
        })
        .catch((reason) => {
            const ventanaConfig = {
                estaVisible: true,
                titulo: "Error en la creación",
                mensaje:
                    "Hubo un error en el envió de la presentación, por favor vuelva a intentarlo",
                esAlerta: true,
                clickAceptar: () => {
                    dispatch({
                        type: actionTypes.ACTUALIZAR_ATRIBUTOS_VENTANA,
                        payload: { estaVisible: false },
                    });
                },
            };
            dispatch({
                type: actionTypes.ACTUALIZAR_ATRIBUTOS_VENTANA,
                payload: ventanaConfig,
            });
            dispatch(
                actualizarAtriutoPresentacion({
                    mostrarBackdrop: false,
                })
            );
        });
};

export const enviarPresentacionActualizada = () => (dispatch, getState) => {
    dispatch(actualizarAtriutoPresentacion({ mostrarBackdrop: true }));

    const {
        idPresentacion,
        prestadorSeleccionado,
        pathTemporal,
        tipoComprobantesSeleccionado,
        emailResponsable,
        telefonoResponsable,
        nroFactura,
        nroReferencia,
        idComprobante,
        facturaFile,
        internaciones,
        prestaciones,
        imagenesFiles,
        liquidacionesFiles,
        tipoPresentacionSeleccionada,
        codigoComprobanteSeleccioado,
        tipoPrestacionSeleccionada,
    } = getState().nuevaPresentacionReducer;

    const idTipoPresentacion =
        tipoPresentacionSeleccionada !== ""
            ? tipoPresentacionSeleccionada
            : prestadorSeleccionado.tipoPresentacion;

    const presentacion = {
        codPrestador: prestadorSeleccionado.codPrestador,
        razonSocial: prestadorSeleccionado.razonSocial,
        idTipoPresentacion: idTipoPresentacion,
        contactoEmail: emailResponsable,
        contactoTelefono: telefonoResponsable,
        tempPath: pathTemporal,
        internaciones: [...internaciones],
        prestaciones: [...prestaciones],
        imagenes: [...imagenesFiles],
        liquidaciones: [...liquidacionesFiles],
        comprobantes: [],
    };

    if (idTipoPresentacion===3){
        delete presentacion.internaciones;
        presentacion.internacionesSocios = internaciones;
    }

    if (facturaFile.length > 0) {
        presentacion.comprobantes = [
            {
                id: idComprobante,
                nroComprobante: nroFactura,
                nroReferencia: nroReferencia,
                detalles: [...facturaFile],
                idTipoComprobante: tipoComprobantesSeleccionado,
                idTipoComprobanteCodigo: codigoComprobanteSeleccioado,
                idTipoPrestacion: tipoPrestacionSeleccionada,
            }
        ]
    }

    axios
        .put("presentaciones/" + idPresentacion, presentacion)
        .then((response) => {
            // Reiniciar los datos actuales de presentacion
            // Enviar al usuario a la grilla de presentaciones
            const ventanaConfig = {
                estaVisible: true,
                titulo: "Actualización exitosa",
                mensaje: `La presentación nº ${response.data} fue actualizada con éxito`,
                clickAceptar: () => {
                    dispatch({
                        type: actionTypes.ACTUALIZAR_ATRIBUTOS_VENTANA,
                        payload: { estaVisible: false },
                    });
                    history.push("/");
                },
            };
            dispatch({
                type: actionTypes.ACTUALIZAR_ATRIBUTOS_VENTANA,
                payload: ventanaConfig,
            });
            dispatch(
                actualizarAtriutoPresentacion({
                    idPresentacion: null,
                    mostrarBackdrop: false,
                })
            );
        })
        .catch((reason) => {
            const ventanaConfig = {
                estaVisible: true,
                titulo: "Error al actualizar",
                mensaje:
                    "Hubo un error en el envió de la presentación, por favor vuelva a intentarlo",
                esAlerta: true,
                clickAceptar: () => {
                    dispatch({
                        type: actionTypes.ACTUALIZAR_ATRIBUTOS_VENTANA,
                        payload: { estaVisible: false },
                    });
                },
            };
            dispatch({
                type: actionTypes.ACTUALIZAR_ATRIBUTOS_VENTANA,
                payload: ventanaConfig,
            });
            dispatch(
                actualizarAtriutoPresentacion({
                    mostrarBackdrop: false,
                })
            );
        });
};

export const buscarDatosPresentacion = (idPresentacion, esEdicion = false) => (
    dispatch
) => {
    dispatch(
        actualizarAtriutoPresentacion({
            mostrarBackdrop: true,
            esEdicion: esEdicion,
            soloVista: !esEdicion,
        })
    );

    axios
        .get("/presentaciones/" + idPresentacion, {
            headers: {
                "Content-type": "application/json",
            },
        })
        .then((response) => {
            dispatch({
                type: actionTypes.CARGAR_DATOS_PRESENTACION,
                payload: response.data,
            });
            dispatch(
                actualizarAtriutoPresentacion({
                    idPresentacion: idPresentacion,
                    mostrarBackdrop: false,
                })
            );
        })
        .catch((error) => {
            dispatch(actualizarAtriutoPresentacion({ mostrarBackdrop: false }));
            let titulo;
            let mensaje;
            if (error.response && error.response.status === 404) {
                titulo = "Error!";
                mensaje = "La presentación no fue encontrada";
            } else {
                titulo = "Hubo un error!";
                mensaje = "Inténtelo nuevamente";
            }
            const ventanaConfig = {
                estaVisible: true,
                titulo,
                mensaje,
                esAlerta: true,
                clickAceptar: () => {
                    history.push("/");
                    dispatch({
                        type: actionTypes.ACTUALIZAR_ATRIBUTOS_VENTANA,
                        payload: { estaVisible: false },
                    });
                },
            };
            dispatch({
                type: actionTypes.ACTUALIZAR_ATRIBUTOS_VENTANA,
                payload: ventanaConfig,
            });
        });
};

export const buscarDatosDeContactoUltimaPresentacion = (codPrestador) => (
    dispatch,
    getState
) => {
    const fetching = getState().nuevaPresentacionReducer.mostrarBackdrop;

    axios
        .get("/presentaciones/contacto", {
            params: { codPrestador: codPrestador },
        })
        .then((response) => {
            dispatch(
                actualizarAtriutoPresentacion({
                    telefonoResponsable: response.data.telefono,
                    emailResponsable: response.data.email,
                })
            );
            if (!fetching) {
                //cuando esta mostrando el backdrop es xq esta levantando los datos de una edicion
                dispatch(
                    actualizarRequeridosEsValido(
                        "emailContacto",
                        response.data.email !== ""
                    )
                );
                dispatch(
                    actualizarRequeridosEsValido(
                        "telefonoContacto",
                        response.data.telefono !== ""
                    )
                );
            }
        });
};

const procesarSubmitValido = (_requeridos, _errores) => {
    let submitValido = true;
    let keys = Object.keys(_requeridos);
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const _atributo = _requeridos[key];

        if (_atributo.requerido && !_atributo.esValido) {
            submitValido = false;
            break;
        }
    }

    let erroresKeys = Object.keys(_errores);
    for (let i = 0; i < erroresKeys.length; i++) {
        const key = erroresKeys[i];
        const _atributo = _errores[key];
        if (!!_atributo) {
            submitValido = false;
            break;
        }
    }
    return submitValido;
};

export const actualizarRequeridos = (atributo, requerido) => (
    dispatch,
    getState
) => {
    const _errores = getState().nuevaPresentacionReducer.errorMensaje;
    const _requeridos = getState().nuevaPresentacionReducer.requeridos;
    _requeridos[atributo].requerido = requerido;

    const submitValido = procesarSubmitValido(_requeridos, _errores);

    dispatch(
        actualizarAtriutoPresentacion({
            requeridos: { ..._requeridos },
            submitValido: submitValido,
        })
    );
};

export const actualizarRequeridosEsValido = (atributo, valido) => (
    dispatch,
    getState
) => {
    const _errores = getState().nuevaPresentacionReducer.errorMensaje;
    const _requeridos = getState().nuevaPresentacionReducer.requeridos;
    _requeridos[atributo].esValido = valido;

    const submitValido = procesarSubmitValido(_requeridos, _errores);

    dispatch(
        actualizarAtriutoPresentacion({
            requeridos: { ..._requeridos },
            submitValido: submitValido,
        })
    );
};

export const actualizarMensajesError = (atributo, mensaje) => (
    dispatch,
    getState
) => {
    const error = {
        [atributo]: mensaje,
    };

    const _errorMensaje = getState().nuevaPresentacionReducer.errorMensaje;

    dispatch(
        actualizarAtriutoPresentacion({
            errorMensaje: { ..._errorMensaje, ...error },
        })
    );
};

export const procesarCargaMasivaInternaciones = () => (dispatch, getState) => {
    const _codPrestador = getState().nuevaPresentacionReducer
        .prestadorSeleccionado.codPrestador;

    const _tempPath = getState().nuevaPresentacionReducer.pathTemporal;
    const _internaciones = getState().nuevaPresentacionReducer.internaciones;
    const idPresentacion = getState().nuevaPresentacionReducer.tipoPresentacionSeleccionada;
    const url = idPresentacion===3?"/presentaciones/internaciones/files/process/obrasocial":`/presentaciones/internaciones/files/process/${_codPrestador}`;
    const body = { internaciones: idPresentacion===3?[]:_internaciones, tempPath: _tempPath };

    dispatch(actualizarAtriutoPresentacion({ mostrarBackdrop: true }));
    axios
        .post(
            url,
            body,
            {
                headers: {
                    "Content-type": "application/json",
                },
            }
        )
        .then((response) => {
            const response_internaciones = response.data;

            if (idPresentacion===3){
                response_internaciones.forEach(i => {
                    const nroInternacion = i.nroDocumento;
                    const nroSocio = i.nroSocio;
                    i.nroInternacion = nroInternacion;
                    i.nroSocio = nroSocio;
                })
                dispatch(actualizarInternaciones([..._internaciones, ...response_internaciones]));
            } else {
                dispatch(actualizarInternaciones(response_internaciones));
            }


            dispatch({
                type: actionTypes.ACTUALIZAR_ATRIBUTOS_ARCHIVOS,
                payload: {
                    uploading: false,
                    subiendoInternacionesMasivo: false,
                },
            });
            dispatch(actualizarAtriutoPresentacion({ mostrarBackdrop: false }));
        });
};

export const actualizarInternacion = (_internacion) => (dispatch, getState) => {
    dispatch({
        type: actionTypes.ACTUALIZAR_INTERNACION,
        payload: _internacion,
    });

    const internaciones = getState().nuevaPresentacionReducer.internaciones;

    const archivosValidos = validarArregloInternaciones(internaciones);
    dispatch(actualizarRequeridosEsValido("internaciones", archivosValidos));

    if (!archivosValidos) {
        dispatch(actualizarAtriutoPresentacion({ submitValido: false }));
    }
};

export const procesarCargaNuevaPresentacion = () => (dispatch, getState) => {
    dispatch(
        actualizarAtriutoPresentacion({
            mostrarNuevaInternacion: false,
        })
    );
    const subiendoInternacion = getState().adjuntarArchivoReducer
        .subiendoNuevaInternacion;
    const _internacion = subiendoInternacion
        ? getState().internacionesReducer.internacion
        : getState().internacionesReducer.internacion_actualizar;
    const idPresentacion = getState().nuevaPresentacionReducer.tipoPresentacionSeleccionada;
    const pathTemporal = getState().nuevaPresentacionReducer.pathTemporal;
    const parametros = { internacion: _internacion, tempPath: pathTemporal };
    axios
        .post("/presentaciones/internaciones/files/process", parametros, {
            headers: {
                "Content-type": "application/json",
            },
        })
        .then((response) => {
            const responseInternacion = response.data;
            if (idPresentacion===3){
                responseInternacion.nroInternacion = _internacion.nroInternacion;
                responseInternacion.nroDocumento = _internacion.nroDocumento;
                responseInternacion.nombreCompleto = _internacion.nombreCompleto;
            }
            dispatch({
                type: actionTypes.ACTUALIZAR_ATRIBUTOS_ARCHIVOS,
                payload: { uploading: false },
            });
            dispatch({
                type: actionTypes.SET_MOSTRAR_PROCESAR_INTERNACION,
                payload: false,
            });
            if (subiendoInternacion) {
                dispatch({
                    type: actionTypes.AGREGAR_INTERNACION,
                    payload: responseInternacion,
                });
                dispatch({ type: actionTypes.REINICIAR_DATOS_INTERNACION });
                dispatch({
                    type: actionTypes.ACTUALIZAR_ATRIBUTOS_ARCHIVOS,
                    payload: { subiendoNuevaInternacion: false },
                });
                dispatch({
                    type: actionTypes.SET_CARGA_ARCHIVOS_INTERNACION,
                    payload: false,
                });

                const requeridos = getState().nuevaPresentacionReducer
                    .requeridos;
                const intValida = validarInternacion(responseInternacion);
                const _internaciones = getState().nuevaPresentacionReducer
                    .internaciones;
                dispatch(
                    actualizarRequeridosEsValido(
                        "internaciones",
                        (requeridos.internaciones.esValido ||
                            _internaciones.length === 1) &&
                            intValida
                    )
                );
            } else {
                dispatch(actualizarInternacion(responseInternacion));
                dispatch({
                    type: actionTypes.RESET_INTERNACION_PARA_ACTUALIZAR,
                });
            }
        });
};

export const eliminarInternacion = (index) => (dispatch, getState) => {
    const _internaciones = getState().nuevaPresentacionReducer.internaciones;
    const _errores = getState().nuevaPresentacionReducer.errorMensaje;

    if (_internaciones[index].id) {
        _internaciones[index].bajaLogica = true;
    } else {
        _internaciones.splice(index, 1);
        //reorganizar errores segun el nuevo index
        const regex = /(nroInternacion)((\d)+)/;
        for (const property in _errores) {
            if (property.match(regex)) {
                let errorIndex = parseInt(property.replace(regex, "$2"));
                if (errorIndex > index) {
                    const value = _errores[property];
                    dispatch(
                        actualizarMensajesError(
                            "nroInternacion" + (errorIndex - 1),
                            value
                        )
                    );
                }

                if (errorIndex === _internaciones.length) {
                    dispatch(
                        actualizarMensajesError(
                            "nroInternacion" + errorIndex,
                            null
                        )
                    );
                }
            }
        }
    }

    dispatch(
        actualizarAtriutoPresentacion({
            internaciones: _internaciones,
        })
    );

    const archivosValidos = validarArregloInternaciones(_internaciones);
    dispatch(actualizarRequeridosEsValido("internaciones", archivosValidos));
};

export const rechazarPresentacion = (idEstado) => (
    dispatch,
    getState
) => {
    const idPresentacion = getState().nuevaPresentacionReducer.idPresentacion;
    return axios
        .patch("/presentaciones/rechazar/" + idPresentacion, {
            idEstado,
        })
        .then(() => {
            dispatch(buscarDatosPresentacion(idPresentacion));
        });
};

// Validacion para no repetir nro de comprobante.
// No tiene que existir el nro de comprobante o tiene 
// que estar dada de baja la presentacion con dicho nro asociado.
export const validaNroCompPresDisp = (nroComprobante,codPrestador,codComprobante) => (
    dispatch
) => {
    axios
        .get("/presentaciones/validaNroComp", {
            params: { nroComprobante: nroComprobante,
                      codPrestador: codPrestador,
                      codComprobante: codComprobante },
        })
        .then((response) => {
            dispatch(
                actualizarMensajesError(
                    "nroComprobante",
                    response.data ? "El N° de comprobante ya fue cargado verifique presentaciones anteriores" : null
                )
            )
            dispatch(
                actualizarRequeridosEsValido("nroComprobante", !response.data)
            )
        });
};